import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1623102583 from "../../../../../packages/component/src/components/slider/demo/demo1.js?loadDemo";
import legacyImportDemo_3150301940 from "../../../../../packages/component/src/components/slider/demo/demo2.js?loadDemo";
import legacyImportDemo_3127774453 from "../../../../../packages/component/src/components/slider/demo/demo3.js?loadDemo";
import legacyImportDemo_3865682546 from "../../../../../packages/component/src/components/slider/demo/demo4.js?loadDemo";
import legacyImportDemo_713669747 from "../../../../../packages/component/src/components/slider/demo/demo5.js?loadDemo";
import legacyImportDemo_4129580272 from "../../../../../packages/component/src/components/slider/demo/demo6.js?loadDemo";
import legacyImportDemo_1344172273 from "../../../../../packages/component/src/components/slider/demo/demo7.js?loadDemo";
import legacyImportDemo_2501494398 from "../../../../../packages/component/src/components/slider/demo/demo8.js?loadDemo";
import legacyImportDemo_93305471 from "../../../../../packages/component/src/components/slider/demo/demo9.js?loadDemo";
import legacyImportDemo_3960679047 from "../../../../../packages/component/src/components/slider/demo/demo10.js?loadDemo";
import legacyImportDemo_2063013862 from "../../../../../packages/component/src/components/slider/demo/demo11.js?loadDemo";
import legacyImportDemo_3601090629 from "../../../../../packages/component/src/components/slider/demo/demo12.js?loadDemo";
import legacyImportDemo_2618647204 from "../../../../../packages/component/src/components/slider/demo/demo13.js?loadDemo";
import legacyImportDemo_1847301123 from "../../../../../packages/component/src/components/slider/demo/demo14.js?loadDemo";
import legacyImportDemo_315931490 from "../../../../../packages/component/src/components/slider/demo/demo15.js?loadDemo";
import legacyImportDemo_1004929473 from "../../../../../packages/component/src/components/slider/demo/demo16.js?loadDemo";
import legacyImportDemo_3248180768 from "../../../../../packages/component/src/components/slider/demo/demo17.js?loadDemo";
import legacyImportDemo_872700303 from "../../../../../packages/component/src/components/slider/demo/demo18.js?loadDemo";
import legacyImportDemo_1992471278 from "../../../../../packages/component/src/components/slider/demo/demo19.js?loadDemo";
import legacyImportDemo_1686688132 from "../../../../../packages/component/src/components/slider/demo/demo20.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1623102583,
  legacyImportDemo_3150301940,
  legacyImportDemo_3127774453,
  legacyImportDemo_3865682546,
  legacyImportDemo_713669747,
  legacyImportDemo_4129580272,
  legacyImportDemo_1344172273,
  legacyImportDemo_2501494398,
  legacyImportDemo_93305471,
  legacyImportDemo_3960679047,
  legacyImportDemo_2063013862,
  legacyImportDemo_3601090629,
  legacyImportDemo_2618647204,
  legacyImportDemo_1847301123,
  legacyImportDemo_315931490,
  legacyImportDemo_1004929473,
  legacyImportDemo_3248180768,
  legacyImportDemo_872700303,
  legacyImportDemo_1992471278,
  legacyImportDemo_1686688132,
  React
};